import { ArrowRightOutlined, DeploymentUnitOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'

const { Title, Paragraph } = Typography

const MECHANIZATION_URL = 'https://mechanization.agro.gov.kg/login'
const BRAND = 'rgb(228, 89, 9)'

export const MechanizationInfo = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: 'calc(100vh - 160px)',
				padding: '24px',
			}}
		>
			<div
				style={{
					maxWidth: '560px',
					width: '100%',
					background: '#ffffff',
					borderRadius: '20px',
					padding: '48px 40px',
					textAlign: 'center',
					boxShadow: '0 12px 40px rgba(0, 0, 0, 0.08)',
					border: '1px solid #f0f0f0',
				}}
			>
				<div
					style={{
						width: '88px',
						height: '88px',
						margin: '0 auto 28px',
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						background: 'rgba(228, 89, 9, 0.1)',
					}}
				>
					<DeploymentUnitOutlined style={{ fontSize: '40px', color: BRAND }} />
				</div>

				<Title level={2} style={{ marginBottom: '16px' }}>
					Мы разработали для вас отдельный сайт
				</Title>

				<Paragraph
					style={{
						fontSize: '16px',
						lineHeight: 1.6,
						color: '#595959',
						marginBottom: '32px',
					}}
				>
					Вы можете перейти туда и попросить доступ у вашего кадровика для получения
					доступа.
				</Paragraph>

				<Button
					type='primary'
					size='large'
					href={MECHANIZATION_URL}
					target='_blank'
					rel='noopener noreferrer'
					style={{
						height: '48px',
						paddingInline: '32px',
						borderRadius: '10px',
						fontSize: '16px',
						fontWeight: 500,
					}}
				>
					Перейти на сайт механизации <ArrowRightOutlined />
				</Button>

				<Paragraph style={{ marginTop: '20px', marginBottom: 0 }}>
					<a
						href={MECHANIZATION_URL}
						target='_blank'
						rel='noopener noreferrer'
						style={{ color: '#8c8c8c', fontSize: '14px' }}
					>
						{MECHANIZATION_URL}
					</a>
				</Paragraph>
			</div>
		</div>
	)
}
